"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiConnector = _interopRequireDefault(require("../ApiConnector"));

var _FetchHelper = _interopRequireDefault(require("./FetchHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TokenValidator =
/*#__PURE__*/
function () {
  function TokenValidator() {
    _classCallCheck(this, TokenValidator);
  }

  _createClass(TokenValidator, null, [{
    key: "isValid",
    value: function isValid(apiHost, obtainTokenMethod) {
      var token;

      if (obtainTokenMethod !== undefined && typeof obtainTokenMethod === 'function') {
        token = obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].get(apiHost + "/token/validate", options).then(function () {
        return true;
      })["catch"](function (e) {
        if (e.httpStatus === 401 || e.httpStatus === 400) {
          return false;
        } else {
          console.error("Failed to validate token! Reason: " + e.error);
        }
      });
    }
  }, {
    key: "validate",
    value: function validate(obtainTokenMethod, removeTokenMethod) {
      var token;

      if (obtainTokenMethod !== undefined && typeof obtainTokenMethod === 'function') {
        token = obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      return _ApiConnector["default"].getInstance().getAuthService().validateToken().then(function () {
        if (token !== undefined && token !== null && token.includes('.')) {
          var tokenArray = token.split('.');

          if (tokenArray[1] !== undefined) {
            var payload = JSON.parse(new Buffer(tokenArray[1], 'base64').toString());

            if (Math.round(new Date().getTime() / 1000) - payload.exp < 0) {
              if (Math.round(new Date().getTime() / 1000) - payload.exp > -600) {
                _ApiConnector["default"].getInstance().getAuthService().refreshToken();
              }
            } else {
              TokenValidator.removeToken(removeTokenMethod);
            }
          } else {
            TokenValidator.removeToken(removeTokenMethod);
          }
        } else {
          TokenValidator.removeToken(removeTokenMethod);
        }
      })["catch"](function (e) {
        if (e.httpStatus === 401 || e.httpStatus === 400) {
          TokenValidator.removeToken(removeTokenMethod);
        } else {
          console.error("Failed to validate token! Reason: " + e.error);
        }
      });
    }
  }, {
    key: "removeToken",
    value: function removeToken(removeTokenMethod) {
      if (removeTokenMethod !== undefined && typeof removeTokenMethod === 'function') {
        removeTokenMethod();
      } else {
        localStorage.removeItem('authentication');
      }
    }
  }]);

  return TokenValidator;
}();

exports["default"] = TokenValidator;